/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginResponse as UserServiceContractLoginResponse } from '../../models/UserService/Contract/login-response';

export interface ApiLoginGetUserDataGet$Params {
}

export function apiLoginGetUserDataGet(http: HttpClient, rootUrl: string, params?: ApiLoginGetUserDataGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UserServiceContractLoginResponse>> {
  const rb = new RequestBuilder(rootUrl, apiLoginGetUserDataGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserServiceContractLoginResponse>;
    })
  );
}

apiLoginGetUserDataGet.PATH = '/api/Login/GetUserData';
